// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ol, ul {
    padding-left: 0rem !important;
}

/* Remove padding from dropdown options */
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    padding-left: 0.5rem !important;
}

::ng-deep .p-dropdown-panel .p-dropdown-items {
    padding-left: 0 !important;
}

/* Character count styling */
.char-count {
  display: block;
  text-align: right;
  font-size: 11px;
  color: #6c757d;
  margin-top: 4px;
}

:host ::ng-deep .ui-panel .ui-panel-titlebar,
:host ::ng-deep .p-panel .p-panel-header {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  border-bottom: 3px solid #3498db !important;
  padding-bottom: 8px !important;
  background: transparent !important;
}

.btn-primary {
    background-color: #3498db;
    border-color: #3498db;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/add-restriction/add-restriction.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA,yCAAyC;AACzC;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;EAC3C,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":["ol, ul {\r\n    padding-left: 0rem !important;\r\n}\r\n\r\n/* Remove padding from dropdown options */\r\n::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {\r\n    padding-left: 0.5rem !important;\r\n}\r\n\r\n::ng-deep .p-dropdown-panel .p-dropdown-items {\r\n    padding-left: 0 !important;\r\n}\r\n\r\n/* Character count styling */\r\n.char-count {\r\n  display: block;\r\n  text-align: right;\r\n  font-size: 11px;\r\n  color: #6c757d;\r\n  margin-top: 4px;\r\n}\r\n\r\n:host ::ng-deep .ui-panel .ui-panel-titlebar,\r\n:host ::ng-deep .p-panel .p-panel-header {\r\n  font-size: 1.5rem !important;\r\n  font-weight: 700 !important;\r\n  color: #2c3e50 !important;\r\n  border-bottom: 3px solid #3498db !important;\r\n  padding-bottom: 8px !important;\r\n  background: transparent !important;\r\n}\r\n\r\n.btn-primary {\r\n    background-color: #3498db;\r\n    border-color: #3498db;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
